export default __webpack_public_path__ + "static/ForgetSectionRight_it-f95a89081ef3ca1ecfc2275ac09d87ff.png";